import { j as s } from "./index.es52.js";
import { composeClassNames as i } from "./index.es184.js";
const c = ({
  children: l = null,
  state: a = "info",
  hasNoIcon: o = !1,
  ...e
}) => /* @__PURE__ */ s.jsxs(
  "div",
  {
    ...e,
    className: i("bl-validation", `bl-validation--${a}`),
    "aria-live": "polite",
    children: [
      !o && /* @__PURE__ */ s.jsx("i", { className: i(`bl-icon--${a}`, "bl-validation__icon") }),
      l
    ]
  }
);
export {
  c as default
};
//# sourceMappingURL=index.es185.js.map
